import React from 'react';
import { useNavigate } from "react-router-dom";
import { padSectionNumber, slugifySectionName } from '../../utils/slugify';

const ExerciseList = ({
  chapter,
  onStartClick,
  progressStartIndex,
  sectionStartNumber,
  firstIncompleteGlobalIdx
}) => {
  let globalProgressIndex = progressStartIndex;
  let sectionNumber = sectionStartNumber; // This is the section's order in the chapter

  return (
    <ul className="exercise-list">
      {chapter.sections.map((item, idx) => {
        let buttonText, buttonProps = {};
        const isDone = item.completed; 
        let clickValue;
        let label;

        if (item.type === "section") {
          clickValue = { sectionNumber, sectionName: item.name };
          label = `Section ${sectionNumber}`;
        } else if (item.type === "bonus") {
          clickValue = "checkpoint";
          label = "Checkpoint";
        } else {
          clickValue = "checkpoint";
          label = "Checkpoint";
        }

        if (isDone) {
          buttonText = "Done";
          buttonProps.className = "exercise-xp completed completed-btn";
          buttonProps.onClick = e => {
            e.stopPropagation();
            onStartClick(clickValue);
          };
        } else if (globalProgressIndex === firstIncompleteGlobalIdx) {
          buttonText = item.xp;
          if (item.type === "bonus") {
            buttonProps.className = "exercise-xp bonus-claim-btn";
          } else {
            buttonProps.className = "exercise-xp start-btn";
          }
          buttonProps.onClick = e => {
            e.stopPropagation();
            onStartClick(clickValue);
          };
        } else {
          buttonText = "Locked";
          buttonProps.className = "exercise-xp locked-btn";
          buttonProps.disabled = true;
          buttonProps.onClick = e => {
            e.stopPropagation();
            onStartClick(clickValue);
          };
        }

        globalProgressIndex++;
        if (item.type === "section") sectionNumber++; // increment for sections

        return (
          <li key={idx} className={`exercise-item${item.type === "bonus" ? " bonus-item" : ""}`}>
            <span>{label}</span>
            <span>{item.name}</span>
            <button {...buttonProps}>{buttonText}</button>
          </li>
        );
      })}
    </ul>
  );
};

function ChapterItem({
  chapter,
  index,
  isOpen,
  onToggle,
  basePath,
  progressStartIndex,
  sectionStartNumber,
  firstIncompleteGlobalIdx,
  courseType
}) {
  const navigate = useNavigate();

  function handleStartClick(value) {
    if (typeof value === "object" && value.sectionNumber && value.sectionName) {
      const paddedNum = padSectionNumber(value.sectionNumber);
      const slug = slugifySectionName(value.sectionName);
      navigate(`/${courseType}/${paddedNum}-${slug}`);
    }
    // else handle checkpoint if needed
  }

  return (
    <li
      className={`chapter-item${isOpen ? ' active' : ''}`}
      onClick={() => onToggle(index)}
    >
      <div className="chapter-header">
        <div className="chapter-number">{index + 1}</div>
        <div className="chapter-title">{chapter.title}</div>
        <i className={`bi bi-chevron-down chapter-dropdown${isOpen ? ' open' : ''}`}></i>
      </div>
      <div className={`chapter-content${isOpen ? ' show' : ''}`}>
        <p className="chapter-description">{chapter.description}</p>
        <ExerciseList
          chapter={chapter}
          onStartClick={handleStartClick}
          progressStartIndex={progressStartIndex}
          sectionStartNumber={sectionStartNumber}
          firstIncompleteGlobalIdx={firstIncompleteGlobalIdx}
        />
      </div>
    </li>
  );
}

export default ChapterItem;